import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const BookTabs = ({ book }) => {
  const [activeTab, setActiveTab] = useState('description');

  const tabs = [
    { id: 'description', label: 'Descripción', icon: 'FileText' }
  ];

  const SpecItem = ({ label, value }) => (
    <div className="flex justify-between py-2 border-b border-border">
      <span className="text-muted-foreground">{label}</span>
      <span className="font-medium">{value}</span>
    </div>
  );

  const renderTabContent = () => {
  // Debug: Log book data to see the structure
  console.log('🔍 BookTabs - Book data:', {
    book,
    featured_point_product: book?.featured_point_product,
    description: book?.description
  });

  switch (activeTab) {
    case 'description':
      return (
        <div className="prose prose-sm max-w-none">
          <div className="whitespace-pre-line text-foreground leading-relaxed">
            {book?.description}
          </div>

          {book?.featured_point_product?.length > 0 && (
            <div className="mt-6">
              <h4 className="font-semibold text-foreground mb-3">Puntos Destacados:</h4>
              <ul className="space-y-2">
                {book.featured_point_product.map((point, index) => (
                  <li key={index} className="flex items-start space-x-2 transition-opacity duration-300 hover:opacity-100 opacity-80">
                    <Icon name="Check" size={16} className="text-success mt-0.5 flex-shrink-0" />
                    <span className="text-foreground">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      );

      default:
        return null;
    }
  };

  return (
    <div className="w-full">
      <div className="border-b border-border mb-6">
        <nav className="flex space-x-8 overflow-x-auto">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center space-x-2 py-3 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-smooth ${
                activeTab === tab.id
                  ? 'border-accent text-accent'
                  : 'border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground'
              }`}
            >
              <Icon name={tab.icon} size={16} />
              <span>{tab.label}</span>
            </button>
          ))}
        </nav>
      </div>

      <div className="min-h-[300px]">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default BookTabs;
               
